/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../../../hocs/withInteractiveFocusable.hoc';

function MiniEpgFilter({
  className,
  focused,
  children,
  onMouseDown,
  onMouseEnter,
  isSelected,
}) {
  return (
    <InteractiveElement
      className={`dtv-html5-c-mini-epg-filter-list__filter ${focused ? 'dtv-html5-c-mini-epg-filter-list__filter--focused' : ''
      } ${isSelected ? 'dtv-html5-c-mini-epg-filter-list__filter--selected' : ''
      } ${className}`}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </InteractiveElement>
  );
}

MiniEpgFilter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  focused: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  isSelected: PropTypes.bool,
};

MiniEpgFilter.defaultProps = {
  className: '',
  onMouseDown: undefined,
  onMouseEnter: undefined,
  isSelected: false,
};

export default memo(withInteractiveFocusable()(memo(MiniEpgFilter)));
